/* KAI RS - varovalo kosarice (25. 9. 2026).
   1) Shopify spremeni kljuc vrstice, ko se dodajo darila ali popusti. Predal pa ostane
      s starimi kljuci, zato "Ukloni" in +/- vrneta napako 400. Po vsaki spremembi
      kosarice (in tik pred klikom) kljuce v predalu uskladimo s pravo kosarico.
   2) Znesek na gumbu "Nastavi na placanje" uskladimo s pravo kosarico. */
(function () {
  'use strict';

  var ROOT = (window.theme && window.theme.routes && window.theme.routes.root_url) || '/';
  if (ROOT.slice(-1) !== '/') ROOT += '/';
  var URL_CART = ROOT + 'cart.js';
  var URL_SECTION = ROOT + '?section_id=api-cart-items';

  var nativeFetch = window.fetch;
  var lastCart = null;
  var timer = null;

  function money(cents) {
    var major = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(major) + ' RSD';
    } catch (e) {
      return major.toFixed(2) + ' RSD';
    }
  }

  function pull() {
    return nativeFetch.call(window, URL_CART, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { lastCart = c; return c; });
  }

  function isMutation(input, opts) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var method = String((opts && opts.method) || (input && input.method) || 'GET').toUpperCase();
    return method === 'POST' && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
  }

  /* Vrne true, ce se predal ujema s kosarico (po popravku kljucev). */
  function heal(cart) {
    var d = document.getElementById('cart-drawer');
    if (!d || !cart || !cart.items) return true;
    var rows = d.querySelectorAll('[data-cart-item]');
    if (!rows.length) return true;
    var used = {};
    var ok = rows.length === cart.items.length;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var oldKey = row.getAttribute('data-item') || '';
      var vid = parseInt(oldKey.split(':')[0], 10);
      var idx = -1, j;
      for (j = 0; j < cart.items.length; j++) {
        if (!used[j] && cart.items[j].key === oldKey) { idx = j; break; }
      }
      if (idx === -1) {
        for (j = 0; j < cart.items.length; j++) {
          if (!used[j] && cart.items[j].variant_id === vid) { idx = j; break; }
        }
      }
      if (idx === -1) { ok = false; continue; }
      used[idx] = true;

      var key = cart.items[idx].key;
      row.setAttribute('data-item-index', String(idx + 1));
      if (key === oldKey) continue;

      row.setAttribute('data-item', key);
      var els = row.querySelectorAll('[data-id]');
      for (var k = 0; k < els.length; k++) {
        if (els[k].getAttribute('data-id') !== oldKey) continue;
        els[k].setAttribute('data-id', key);
        if (els[k].id === 'updates_' + oldKey) els[k].id = 'updates_' + key;
      }
      var links = row.querySelectorAll('a[href*="/cart/change"]');
      for (var m = 0; m < links.length; m++) {
        links[m].setAttribute('href', ROOT + 'cart/change?line=' + (idx + 1) + '&quantity=0');
      }
    }
    return ok;
  }

  function syncTotal(cart) {
    if (!cart || !cart.item_count) return;
    var nodes = document.querySelectorAll('[data-cart-total-price]');
    for (var i = 0; i < nodes.length; i++) {
      var txt = money(cart.total_price);
      if (nodes[i].textContent !== txt) nodes[i].textContent = txt;
    }
    var qty = document.querySelectorAll('[data-cart-items-qty]');
    for (var q = 0; q < qty.length; q++) {
      var cur = qty[q].textContent;
      var next = cur.replace(/\d+/, String(cart.item_count));
      if (next !== cur) qty[q].textContent = next;
    }
  }

  function refreshLines() {
    var d = document.getElementById('cart-drawer');
    var holder = d && d.querySelector('[data-items-holder]');
    if (!holder) return Promise.resolve();
    return nativeFetch.call(window, URL_SECTION, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'text/html');
        var lines = doc.querySelector('[data-api-line-items]');
        var price = doc.querySelector('[data-api-cart-price]');
        var priceHolder = d.querySelector('[data-cart-price-holder]');
        if (lines) holder.innerHTML = lines.innerHTML;
        if (priceHolder && price) priceHolder.innerHTML = price.innerHTML;
      });
  }

  function sync() {
    pull().then(function (cart) {
      syncTotal(cart);
      if (heal(cart)) return;
      return refreshLines().then(pull).then(function (c) { heal(c); syncTotal(c); });
    }).catch(function (e) { console.warn('KAI varovalo:', e); });
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(sync, delay || 900);
  }

  window.fetch = function (input, opts) {
    var p = nativeFetch.apply(this, arguments);
    try {
      if (isMutation(input, opts)) p.then(function () { schedule(); }, function () { schedule(); });
    } catch (e) {}
    return p;
  };

  /* Tik pred klikom na Ukloni ali +/- popravi kljuce z zadnjim znanim stanjem. */
  function beforeAction(e) {
    var t = e.target && e.target.closest && e.target.closest('[data-item-remove],[data-quantity-button],[data-quantity-field]');
    if (t && lastCart) heal(lastCart);
  }
  document.addEventListener('click', beforeAction, true);
  document.addEventListener('change', beforeAction, true);

  /* Ob odprtju predala osvezi stanje. */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-cart-toggle],a[href="/cart"],a[href$="/cart"]');
    if (t) schedule(600);
  }, true);

  pull().catch(function () {});
})();